export default __webpack_public_path__ + "static/media/Large conference room_V.3.f77e1aca.jpg";